import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  businessUnitsKeys,
  RequestTypes,
} from '@core/react-query/features/businessUnits'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { profileKeys } from '@core/react-query/features/profile/profileKeys'

export const useCreateBusinessUnit = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['createBusinessUnit']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...businessUnitsKeys.createBusinessUnit,
    retry: 0,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessUnitsKeys._def })
      queryClient.invalidateQueries({
        queryKey: profileKeys.getUserStats._def,
      })
    },
  })
}
